import { useMemo } from 'react';
import useSWR, { mutate } from 'swr';

import { fetcher, endpoints } from 'src/utils/axios';

const swrOptions = { revalidateOnFocus: false, keepPreviousData: true };

export function useGetWorkGroups() {
  const URL = endpoints.work_groups.all;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, swrOptions);
  const memoizedValue = useMemo(
    () => ({
      workGroupsData: data || [],
      loading: isLoading,
      error,
      validating: isValidating,
      empty: !isLoading && !data?.length,
    }),
    [data, error, isLoading, isValidating]
  );
  const refetch = async () => {
    // Use the mutate function to re-fetch the data for the specified key (URL)
    await mutate(URL);
  };

  return { ...memoizedValue, refetch };
}

export function useGetDepartmentWorkGroups(id) {
  const URL = endpoints.work_groups.department.all(id);

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, swrOptions);
  const memoizedValue = useMemo(
    () => ({
      workGroupsData: data || [],
      loading: isLoading,
      error,
      validating: isValidating,
      empty: !isLoading && !data?.length,
    }),
    [data, error, isLoading, isValidating]
  );
  const refetch = async () => {
    // Use the mutate function to re-fetch the data for the specified key (URL)
    await mutate(URL);
  };

  return { ...memoizedValue, refetch };
}

export function useGetDepartmentActiveWorkGroups(id) {
  const URL = endpoints.work_groups.department.active(id);

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, swrOptions);
  const memoizedValue = useMemo(
    () => ({
      workGroupsData: data || [],
      loading: isLoading,
      error,
      validating: isValidating,
      empty: !isLoading && !data?.length,
    }),
    [data, error, isLoading, isValidating]
  );
  const refetch = async () => {
    // Use the mutate function to re-fetch the data for the specified key (URL)
    await mutate(URL);
  };

  return { ...memoizedValue, refetch };
}

export function useGetUSWorkGroups(id) {
  const URL = endpoints.work_groups.unit_service.all(id);

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, swrOptions);
  const memoizedValue = useMemo(
    () => ({
      workGroupsData: data || [],
      loading: isLoading,
      error,
      validating: isValidating,
      empty: !isLoading && !data?.length,
    }),
    [data, error, isLoading, isValidating]
  );
  const refetch = async () => {
    // Use the mutate function to re-fetch the data for the specified key (URL)
    await mutate(URL);
  };

  return { ...memoizedValue, refetch };
}

export function useGetUSActiveWorkGroups(id) {
  const URL = endpoints.work_groups.unit_service.active(id);

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, swrOptions);
  const memoizedValue = useMemo(
    () => ({
      workGroupsData: data || [],
      loading: isLoading,
      error,
      validating: isValidating,
      empty: !isLoading && !data?.length,
    }),
    [data, error, isLoading, isValidating]
  );
  const refetch = async () => {
    // Use the mutate function to re-fetch the data for the specified key (URL)
    await mutate(URL);
  };

  return { ...memoizedValue, refetch };
}

export function useGetEmployeeWorkGroups(id) {
  const URL = endpoints.work_groups.employee.all(id);

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, swrOptions);
  const memoizedValue = useMemo(
    () => ({
      workGroupsData: data || [],
      loading: isLoading,
      error,
      validating: isValidating,
      empty: !isLoading && !data?.length,
    }),
    [data, error, isLoading, isValidating]
  );
  const refetch = async () => {
    // Use the mutate function to re-fetch the data for the specified key (URL)
    await mutate(URL);
  };

  return { ...memoizedValue, refetch };
}

export function useGetEmployeeActiveWorkGroups(id) {
  const URL = endpoints.work_groups.employee.active(id);

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, swrOptions);
  const memoizedValue = useMemo(
    () => ({
      workGroupsData: data || [],
      loading: isLoading,
      error,
      validating: isValidating,
      empty: !isLoading && !data?.length,
    }),
    [data, error, isLoading, isValidating]
  );
  const refetch = async () => {
    // Use the mutate function to re-fetch the data for the specified key (URL)
    await mutate(URL);
  };

  return { ...memoizedValue, refetch };
}

export function useGetWorkGroup(id) {
  const URL = endpoints.work_groups.one(id);

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, swrOptions);
  const memoizedValue = useMemo(
    () => ({
      data: data || {},
      loading: isLoading,
      error,
      validating: isValidating,
      empty: !isLoading && !data?.length,
    }),
    [data, error, isLoading, isValidating]
  );

  const refetch = async () => {
    // Use the mutate function to re-fetch the data for the specified key (URL)
    await mutate(URL);
  };

  return { ...memoizedValue, refetch };
}
